export default "__VITE_ASSET__DTtZIP17__"